<template>
  <div class="search-related">
    <div class="search-related-title">
      <h3>Related Searches</h3>
    </div>
    <div class="search-related-topics">
      <div
        class="search-related-topic"
        v-bind:key="topic.name"
        v-for="topic in relatedSearches"
      >
        <div class="search-related-topic-title">
          <h4>By {{ topic.name }}</h4>
        </div>
        <div class="search-related-topic-links">
          <div
            class="search-related-topic-link"
            v-for="cluster in topic.clusters"
          >
            <button type="button" v-on:click="searchRelated(cluster)">
              {{ cluster.label }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "SearchRelated",

  computed: {
    ...mapState({
      relatedSearches: (state) => state.search.relatedSearches,
    }),

    searchInput: {
      get() {
        return this.$store.getters.searchInput;
      },
      set(value) {
        this.$store.commit("setSearchInput", value);
      },
    },
  },

  methods: {
    searchRelated(cluster) {
      if (cluster.query) {
        this.searchInput = cluster.label;
      }
      this.$store
        .dispatch("fetchSearchResultsWithPrebuiltQuery", cluster.href)
        .then((response) => {})
        .catch((err) => {
          console.error(err);
        });
    },
  },
};
</script>

<style scoped>
.search-related {
  padding: 20px;
  border: 1px solid var(--wwfTransparentBlack015);
}

.search-related-topics {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
  white-space: nowrap;
}

.search-related-topic {
  flex: 1;
  margin: 8px
}

.search-related-topic-link button {
  color: var(--wwfOrange);
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// searchRelated.vue?6fb39a52